export const getViewDataPairs = (items, attr, n) => {
  let totalCount = 0;
  const counter = {};
  items.forEach(item => {
    const value = item[attr];
    if (value && value !== 'Other' && value !== 'N/A') {
      totalCount += 1;
      counter[value] = counter[value] ? counter[value] + 1 : 1;
    }
  });
  const pairs = Object.keys(counter)
    .map(value => [value, (100 * counter[value]) / totalCount])
    .sort((a, b) => b[1] - a[1]);
  const topPairs = pairs.slice(0, n);
  const other = 100 - pairs.slice(0, n).reduce((acc, pair) => acc + pair[1], 0);
  if (other > 0.01) topPairs.push(['Other', other]);
  const otherPairs = pairs.slice(n);
  return { topPairs, otherPairs };
};
